import { imgUrl } from "@/lib/glossyApi";

/** Reusable free image picker over the member's AI Images Saved gallery. */
export default function SavedImagePicker({ member, current, note, tid, onPick, busy }) {
  const shots = [...(member.shot_gallery || [])].reverse();
  return (
    <div className="mt-3 border border-ink/15 p-3" data-testid={`${tid}-picker`}>
      <p className="overline text-[10px] text-ink/60 mb-2">{note || "Pick any saved image — free, no credits"}</p>
      {shots.length === 0 ? (
        <p className="font-mono text-[11px] text-ink/45 p-4 text-center">No saved images yet.</p>
      ) : (
        <div className="grid grid-cols-4 sm:grid-cols-8 gap-2 max-h-64 overflow-y-auto">
          {shots.map((g) => (
            <button key={g.id} onClick={() => onPick(g.image)} disabled={!!busy}
              className={`relative aspect-[3/4] overflow-hidden border-2 transition-colors ${current === g.image ? "border-gloss-gold" : "border-transparent hover:border-ink"}`}
              data-testid={`${tid}-pick-${g.id}`}>
              <img src={imgUrl({ cover_image: g.image })} alt="" className="w-full h-full object-cover" loading="lazy" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
